import { useParams } from "react-router-dom";
import ViewChecklists from "@swivu/shared-ui/src/components/ViewChecklists.js";

const ViewChecklistsWrapper = () => {
  const { id, slug } = useParams<{ id: string; slug: string }>();

  return (
    <ViewChecklists.Provider
      api="public"
      id={id as string}
      slug={slug as string}
      baseLink={`/p/${slug}/checklists/${id}/checklist`}
    >
      <div className="py-4">
        <ViewChecklists />
      </div>
    </ViewChecklists.Provider>
  );
};

ViewChecklistsWrapper.Skeleton = ViewChecklists.Skeleton;
export default ViewChecklistsWrapper;
